
import { updateAppConfig } from '#app'
import { defuFn } from '/var/jenkins_home/workspace/hn-wy-website/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "ff989e84-8001-48bd-9ab2-11eb10df4941"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
